import { useThemeStore } from '~/components/theme-controller/stores/useThemeStore';
import { isDarkTheme } from '~/components/theme-controller/utils/theme-utils/theme-utils';

import { prepareChartFonts } from './copyAlfredCharts';
import { renderChartNodeToHtml } from './copyChartDom';
import { getCanvasDataUrl } from './fetchStylesUtils';

const replaceButtonsWithDivs = (clone: HTMLDivElement) => {
  clone.querySelectorAll('button').forEach(button => {
    const div = document.createElement('div');

    Array.from(button.attributes).forEach(({ name, value }) =>
      div.setAttribute(name, value)
    );

    while (button.firstChild) {
      div.appendChild(button.firstChild);
    }

    button.parentNode?.replaceChild(div, button);
  });
};

const replaceCanvasesWithImages = (
  source: HTMLDivElement,
  clone: HTMLDivElement,
  shouldInvertCanvas: boolean
) => {
  const originalCanvases = source.querySelectorAll('canvas');
  const clonedCanvases = clone.querySelectorAll('canvas');

  originalCanvases.forEach((canvas, index) => {
    const clonedCanvas = clonedCanvases[index];

    if (clonedCanvas) {
      const img = document.createElement('img');
      img.src = getCanvasDataUrl(canvas, shouldInvertCanvas);

      const computedStyle = window.getComputedStyle(canvas);

      for (let i = 0; i < computedStyle.length; i += 1) {
        const property = computedStyle.item(i);
        img.style.setProperty(
          property,
          computedStyle.getPropertyValue(property),
          computedStyle.getPropertyPriority(property)
        );
      }

      img.style.width = computedStyle.width;
      img.style.height = computedStyle.height;

      clonedCanvas.parentNode?.replaceChild(img, clonedCanvas);
    }
  });
};

export const renderChartV2Node = async (
  chartNode: HTMLDivElement
): Promise<string> => {
  const shouldInvertCanvas = isDarkTheme(useThemeStore.getState().themeName);
  const fontCss = await prepareChartFonts();

  return renderChartNodeToHtml(chartNode, {
    width: chartNode.clientWidth,
    height: chartNode.clientHeight,
    fontCss,
    prepareClone: (clone, source) => {
      clone.style.boxSizing = 'content-box';
      clone.style.width = `${source.clientWidth}px`;
      clone.style.height = `${source.clientHeight}px`;
      clone.style.overflow = 'visible';
      clone.style.border = 'none';
      clone.style.borderRadius = '0';
      clone.style.boxShadow = 'none';

      replaceButtonsWithDivs(clone);
      replaceCanvasesWithImages(source, clone, shouldInvertCanvas);
    },
  });
};
